/* tslint:disable */
/* eslint-disable */
/**
 * KDS API
 * Internal KDS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Sync200ResponseOneOf } from './Sync200ResponseOneOf';
import {
    instanceOfSync200ResponseOneOf,
    Sync200ResponseOneOfFromJSON,
    Sync200ResponseOneOfFromJSONTyped,
    Sync200ResponseOneOfToJSON,
} from './Sync200ResponseOneOf';
import type { Sync200ResponseOneOf1 } from './Sync200ResponseOneOf1';
import {
    instanceOfSync200ResponseOneOf1,
    Sync200ResponseOneOf1FromJSON,
    Sync200ResponseOneOf1FromJSONTyped,
    Sync200ResponseOneOf1ToJSON,
} from './Sync200ResponseOneOf1';

/**
 * @type Sync200Response
 * 
 * @export
 */
export type Sync200Response = Sync200ResponseOneOf | Sync200ResponseOneOf1;

export function Sync200ResponseFromJSON(json: any): Sync200Response {
    return Sync200ResponseFromJSONTyped(json, false);
}

export function Sync200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sync200Response {
    if (json == null) {
        return json;
    }
    if (instanceOfSync200ResponseOneOf(json)) {
        return Sync200ResponseOneOfFromJSONTyped(json, true);
    }
    if (instanceOfSync200ResponseOneOf1(json)) {
        return Sync200ResponseOneOf1FromJSONTyped(json, true);
    }

    return {} as any;
}

export function Sync200ResponseToJSON(json: any): any {
    return Sync200ResponseToJSONTyped(json, false);
}

export function Sync200ResponseToJSONTyped(value?: Sync200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfSync200ResponseOneOf(value)) {
        return Sync200ResponseOneOfToJSON(value as Sync200ResponseOneOf);
    }
    if (instanceOfSync200ResponseOneOf1(value)) {
        return Sync200ResponseOneOf1ToJSON(value as Sync200ResponseOneOf1);
    }

    return {};
}

